import React, { Component } from "react";
import background from "../../imgs/background.png";
import Store from "../../imgs/store.png";
import Bank from "../../imgs/Bank.png";
import Pizza from "../../imgs/pizza.png";
import Town from "../../imgs/Town_Hall.png";

import Miami from "../../imgs/Miami.png";
import One from "../../imgs/1.png";
import Two from "../../imgs/2.png";
import Three from "../../imgs/3.png";
import Four from "../../imgs/4.png";
import Five from "../../imgs/5.png";
import Six from "../../imgs/6.png";
import Seven from "../../imgs/7.png";
import Eight from "../../imgs/8.png";

import { Link } from "react-router-dom";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }
  componentDidMount = () => {
    setTimeout(() => this.setState({ loading: false }), 3000);
  };
  render() {
    return (
      <div>
        {this.state.loading ? (
          <div id="overlay" style={{ display: "fixed" }}>
            <div className="spinner" />
            <br />
            <h6 className="text-md losnello text-dark">
              Dope Stuff Loading...
            </h6>
          </div>
        ) : null}

        <div className="header-container">
          <img className="background" src={Miami} />
          <a
            href="https://magiceden.io/marketplace/777_dope_pandas"
            target="_blank"
          >
            <img className="store" src={One} />
          </a>
          <a href="/comingsoon">
            <img className="bank" src={Five} />
          </a>
          <a target="_blank" href="https://twitter.com/dopegallerylabs">
            <img className="pizza" src={Two} />
          </a>
          <a href="https://moonrank.app/collection/777_dope_pandas">
            <img className="cinema" src={Three} />
          </a>
          <a href="/about">
            <img className="tent" src={Six} />
          </a>
          <a target="_blank" href="https://discord.gg/dopegallerylabs">
            <img className="town" src={Four} />
          </a>
          <a
            target="_blank"
            href="https://magiceden.io/launchpad/3d_intergalactic_pandas"
          >
            <img className="sign" src={Seven} />
          </a>
          <a href="/comingsoon">
            <img className="art" src={Eight} />
          </a>
        </div>
      </div>
    );
  }
}
